export default __webpack_public_path__ + "static/media/farmacia-copia.84ba51de.jpg";